import { AvailabilityTypes } from '~/constants/reportType';
import { IReportType } from '~/types/models/reportType';
import { IJobItemRequest } from '~/types/request/jobItem';

export const filterReportTypesByAvailability = (reportType: IReportType, currentJobItem: IJobItemRequest | null) => {
  const jobItemType = currentJobItem?.jobItemType;
  if (!jobItemType) {
    return Boolean(reportType.availableFor.jobcard);
  }

  return Boolean(reportType.availableFor[AvailabilityTypes[jobItemType]]);
};
